import clone from 'clone';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';
import {OEImplantcastTargetType, opTargets as implantcastOpTargets, OEImplantcastStartSelectionContent} from '../implantcast/oe-implantcast-consts';

export const OEMediCADemyTargetType = {
    implantcast:        'implantcast',
    ido:                'ido',
    ohst:               'ohst',
};

OEMediCADemyTargetType.all = [
    OEMediCADemyTargetType.implantcast,
    OEMediCADemyTargetType.ido,
    OEMediCADemyTargetType.ohst,
];

export const implantcastTargets = implantcastOpTargets.filter(target => target !== OETarget.materialTestTarget);

//
const filterStartSelectionCategory = function(categories, target)   {
    if(!Array.isArray(categories))  return categories;

    // make a deep copy here because we modify its contents!
    categories = clone(categories);

    //
    return categories.filter(cat => {
        if(!Array.isArray(cat.subcategories)) return true;
        let removed = false;
        cat.subcategories = cat.subcategories.filter(subcat => {
            if(!Array.isArray(subcat.items) || subcat.items.findIndex((item) => typeof(item) === 'object' && item.target === target) < 0)    return true;
            subcat.items = subcat.items.filter((item) => typeof(item) === 'object' && item.target !== target);
            removed = true;
            return subcat.items.length > 0;
        });
        return !removed || cat.subcategories.length > 0;
    });
};

//
export const OEMediCADemyStartSelectionContent = {

    [OEMediCADemyTargetType.implantcast]: filterStartSelectionCategory(OEImplantcastStartSelectionContent[OEImplantcastTargetType.op], OETarget.materialTestTarget),

    [OEMediCADemyTargetType.ido]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryIdo,
                    ]
                }
            ]
        }
    ],

    [OEMediCADemyTargetType.ohst]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryOHSTPrimaCurve,
                    ]
                }
            ]
        }
    ],

    [OEMediCADemyTargetType.implantcast + OEAlphaBetaProdTypes.beta]: filterStartSelectionCategory(OEImplantcastStartSelectionContent[OEImplantcastTargetType.op + OEAlphaBetaProdTypes.beta], OETarget.materialTestTarget),

    [OEMediCADemyTargetType.ido + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryIdo,
                    ]
                }
            ]
        }
    ],

    [OEMediCADemyTargetType.ohst + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryOHSTPrimaCurve,
                    ]
                }
            ]
        }
    ],

    [OEMediCADemyTargetType.implantcast + OEAlphaBetaProdTypes.prod]: filterStartSelectionCategory(OEImplantcastStartSelectionContent[OEImplantcastTargetType.op + OEAlphaBetaProdTypes.prod], OETarget.materialTestTarget),

    [OEMediCADemyTargetType.ido + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryIdo,
                    ]
                }
            ]
        }
    ],

    [OEMediCADemyTargetType.ohst + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryOHSTPrimaCurve,
                    ]
                }
            ]
        }
    ],
};

OEMediCADemyStartSelectionContent.modules = [
    {id: OEMediCADemyTargetType.implantcast, icon: OEIconCodes.mediCADemy.implantcastTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.implantcast]},
    {id: OEMediCADemyTargetType.ido, icon: OEIconCodes.mediCADemy.idoTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.ido]},
    {id: OEMediCADemyTargetType.ohst, icon: OEIconCodes.mediCADemy.ohstTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.ophthohstalmology]},
];

OEMediCADemyStartSelectionContent.modulesBeta = [
    {id: OEMediCADemyTargetType.implantcast, icon: OEIconCodes.mediCADemy.implantcastTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.implantcast + OEAlphaBetaProdTypes.beta]},
    {id: OEMediCADemyTargetType.ido, icon: OEIconCodes.mediCADemy.idoTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.ido + OEAlphaBetaProdTypes.beta]},
    {id: OEMediCADemyTargetType.ohst, icon: OEIconCodes.mediCADemy.ohstTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.ophthohstalmology + OEAlphaBetaProdTypes.beta]},
];

OEMediCADemyStartSelectionContent.modulesProduction = [
    {id: OEMediCADemyTargetType.implantcast, icon: OEIconCodes.mediCADemy.implantcastTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.implantcast + OEAlphaBetaProdTypes.prod]},
    {id: OEMediCADemyTargetType.ido, icon: OEIconCodes.mediCADemy.idoTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.ido + OEAlphaBetaProdTypes.prod]},
    {id: OEMediCADemyTargetType.ohst, icon: OEIconCodes.mediCADemy.ohstTarget, categories: OEMediCADemyStartSelectionContent[OEMediCADemyTargetType.ophthohstalmology + OEAlphaBetaProdTypes.prod]},
];
